import { Providers } from '@/app/providers';
import { AppRouter } from '@/app/routes';
import '@/app/i18n/config';
import '@/styles/index.scss';

function App() {
  return (
    <Providers>
      <AppRouter />
    </Providers>
  );
}

export default App;
